import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d6d23da&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5d6d23da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6d23da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6d23da')) {
      api.createRecord('5d6d23da', component.options)
    } else {
      api.reload('5d6d23da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5d6d23da&scoped=true&", function () {
      api.rerender('5d6d23da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homePageCopyWriter/index.vue"
export default component.exports